import React, {useState} from "react";
import styles from "./FormikPriceInput.module.scss";
import NumberFormat from "react-number-format";
import {Field} from 'formik';
import {currencyValueToLabel} from "../formikCurrencySelector/FormikCurrencySelector";
import {trimNumberMinMax} from 'data/utils/calculators';
import CustomTextField from 'gui/components/customTextField';

export interface IPriceInputProps {
  name: string;
  label: string | any;
  currency?: number;
  min: number;
  max: number;
  noBorder?: boolean;

  className?: string;

  endAdornment?: any;
}


interface NumberFormatCustomProps {
  inputRef: (instance: NumberFormat<any> | null) => void;
  onChange: (event: { target: { name: string; value: number } }) => void;
  name: string;
  currency?: string;
  min: number;
  max: number;
}

const deleteIfNoChange = [];
const NF: any = NumberFormat;
const NumberFormatCustom = (props: NumberFormatCustomProps) => {
  const {min, max, inputRef, onChange, currency, onBlur, onFocus, ...other}: any = props;
  const [lastValue, setLastValue] = useState(other.value);
  return (
    <NF
      {...other}
      className={`${styles.formikPriceInput} ${other.className}`.trim()}
      getInputRef={inputRef}
      onKeyDown={(a) => {
        const t: any = a.currentTarget;
        if (a.key === 'Backspace' && t.selectionEnd < t.value.length) {
          deleteIfNoChange.push(other.value);
          setTimeout(() => {
            if (deleteIfNoChange.includes(other.value)) {
              onChange({
                target: {
                  name: props.name,
                  value: `${other.value}`.slice(1)
                },
              });
              deleteIfNoChange.splice(deleteIfNoChange.indexOf(other.value), 1);
            }
          }, 10);
        }
      }}
      onValueChange={(values) => {
        deleteIfNoChange.splice(deleteIfNoChange.indexOf(other.value), 1);
        setLastValue(values.floatValue);
        onChange({
          target: {
            name: props.name,
            value: isNaN(values.floatValue) ? "" : values.floatValue
          },
        });
      }
      }
      allowLeadingZeros={false}
      allowNegative={false}
      thousandSeparator
      isNumericString
      onBlur={(a) => {
        try {
          onBlur(a);
          if (typeof other.value === 'number') {
            onChange({
              target: {
                name: props.name,
                value: trimNumberMinMax(other.value, min, max),
              },
            });
          }
        } catch (e) {
        }
      }}
      onFocus={(a) => {
        try {
          onFocus(a);
          if (typeof other.value === 'number') {
            onChange({
              target: {
                name: props.name,
                value: trimNumberMinMax(other.value, min, max),
              },
            });
          }
        } catch (e) {
        }
      }}
      prefix={currency ? `${currencyValueToLabel[currency]} ` : ""}
    />
  );
}

const CustomizedTextField = ({field, form, min, max, ...props}: any) => {
  const touched = form.touched[field.name] || form.submitCount > 0;
  const error = touched && form.errors[field.name];
  const value = field.value;
  const valid = touched && !error || (isNaN(value) ? false : value > props.min);
  return (
    <CustomTextField
      {
        ...({...props, ...field})
      }
      className={`${props.className || ''} ${valid ? "valid" : ""} ${error ? "error" : ""}`.trim()}

      inputProps={
        {
          ...field,
          currency: props.currency,
          min: min,
          max: max,
          inputMode: "numeric",
          pattern: "\d*"
        }
      }
      error={error}
    />
  );
}

const FormikPriceInput = ({endAdornment, ...props}: IPriceInputProps) => (
  <Field
    component={CustomizedTextField}
    InputProps={{
      currency: props.currency,
      inputComponent: NumberFormatCustom as any,
      min: props.min,
      max: props.max,
      ...(endAdornment !== undefined ? {endAdornment: endAdornment} : {})
    }}
    required
    fullWidth
    variant="outlined"
    id={props.name}
    {...props}
  />
);

FormikPriceInput.defaultProps = {
  name: "",
  label: "",
  currency: null,
  min: 0,
  max: 999999999999999
};

export default FormikPriceInput;
